<template>
  <div :class="'cg tag'+type">{{ getName() }}</div>
</template>
<script>
export default {
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getName() {
      if (this.type == 1) return '特价促销';
      if (this.type == 2) return '定时打折';
      if (this.type == 3) return '买赠活动';
      if (this.type == 4) return '满赠活动';
    }
  }
};
</script>

<style lang="less" scoped>
.cg {
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  padding: 0 10px;
  border-radius: 4px;
  margin-right: 10px;
  cursor: pointer;
}
.tag1 {
  color: #F90000;
  background: #FFECEC;
  border: 1px solid #FFC1C1;
}
.tag2 {
  color: #F7B900;
  background: #fffcf3;
  border: 1px solid #fff0c3;
}
.tag3 {
  color: #4086FF;
  background: #e7eefb;
  border: 1px solid #bfd7ff;
}
.tag4 {
  color: #FF6740;
  background: #ffeeea;
  border: 1px solid #ffcbbe;
}
</style>
